// Utils/Helpers
import { getRandomNumber, getUniqueRandomNumbersArray } from '@/utils/randomNumber';

// Types
import type { FAQArticleType, FAQCategoryType } from '@/lib/home/FAQList';

// Constants/Libs
import { FAQList } from '@/lib/home/FAQList';

// Components
import FAQArticle from '@/components/pages/home/newsArticles/FAQArticle';

const get2RandomArticles = (categories: FAQCategoryType[], FAQList: FAQArticleType[]) => {
    const newArr =
        categories.length > 0
            ? FAQList.filter((article) => categories.includes(article.category))
            : FAQList;

    if (newArr.length === 0) {
        const randomNumbers = getUniqueRandomNumbersArray(2, 0, FAQList.length - 1);
        return [FAQList[randomNumbers[0]], FAQList[randomNumbers[1]]];
    } else if (newArr.length === 1) {
        let randomNumber = getRandomNumber(0, FAQList.length - 1);
        let article = FAQList[randomNumber];
        while (article.id === newArr[0].id) {
            randomNumber = getRandomNumber(0, FAQList.length - 1);
            article = FAQList[randomNumber];
        }

        newArr.push(article);

        return newArr;
    }

    const randomNumbers = getUniqueRandomNumbersArray(2, 0, newArr.length - 1);
    return [newArr[randomNumbers[0]], newArr[randomNumbers[1]]];
};

const FAQArticles = () => {
    const faqDisplayed = get2RandomArticles([], FAQList);
    return (
        <>
            {faqDisplayed.map((faqArticle: FAQArticleType) => {
                return <FAQArticle faqArticle={faqArticle} key={faqArticle?.id} />;
            })}
        </>
    );
};

export default FAQArticles;
